// extracted by mini-css-extract-plugin
module.exports = {"dialogContent":"FieldStatisticsEditContainer_dialogContent__3dDBy"};